import { version } from '../../package.json'
import { Link } from 'react-router-dom'
import useOnboard from '../hooks/useOnboard'
import useAuth from '../models/useAuth'
import { Z_INDEX } from '../constants'
import Stack from '@mui/material/Stack'
import Logo from './Logo'
import Button from '@mui/material/Button'
import OrgSelector from './OrgSelector'
import useGraphView from '../models/useGraphView'

export default function Header() {
  const onboard = useOnboard()
  const { session } = useAuth()
  // On the map the logo has no box behind it (Benoit, 2026-10-02, nobgp/app#449). On the graph
  // the box is the page colour and keeps a node that passes under the logo off its letters.
  const mapView = useGraphView(s => s.mapView)

  const sx = { letterSpacing: 0.5, fontWeight: 400 }

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        zIndex: Z_INDEX.GRAPH + 1
      }}>
      <Link to="/" title={`version ${version}`}>
        <Logo
          sx={theme =>
            mapView
              ? {}
              : {
                  borderBottomRightRadius: theme.shape.borderRadiusLarge,
                  backdropFilter: theme.shape.backdropBlur,
                  backgroundColor: theme.palette.transparent.lighten,
                }
          }
        />
      </Link>
      <Button color="inherit" href="https://docs.nobgp.com" sx={sx}>
        Docs
      </Button>
      {onboard && session && (
        <Button color="inherit" to="/onboard/welcome" component={Link} sx={sx}>
          Get Started
        </Button>
      )}
      {session && <OrgSelector />}
    </Stack>
  )
}
